module.exports = __webpack_public_path__ + "img/birthday_eve.ca90109b.svg";